import * as React from 'react';
import { IDetailDW } from 'desktop--design-library';
import { observer } from 'mobx-react';

export interface ILiveEventOddsProps {
    detail: IDetailDW;
    gameHasDetails: boolean;
    children: React.ReactNode;
}

export const LiveEventOdds: React.FC<ILiveEventOddsProps> = observer((props: ILiveEventOddsProps) => {

    return <div className="game-detail px-2 mb-2">
        {props.gameHasDetails ? props.detail.name : ''}
        <div className={"odds d-flex justify-content-between flex-wrap "}
        >
            {props.children}
        </div>
    </div>
});